import { SvgIcon } from "@mui/material";

const Pencil = (props) => {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M19.2666 10.0703L13.9287 4.73242L3.90579 14.7594C3.47876 15.1865 3.1667 15.7161 2.99424 16.2951L1.5407 21.2388C1.43805 21.5837 1.53249 21.9573 1.79117 22.2119C2.04985 22.4665 2.4194 22.5609 2.7643 22.4624L7.7039 21.0089C8.28285 20.8364 8.81253 20.5243 9.23956 20.0973L19.2666 10.0703ZM5.16635 16.3033L6.09843 15.9297V17.2436C6.09843 17.6049 6.39406 17.9006 6.7554 17.9006H8.06933L7.69568 18.8326C7.53144 18.9599 7.34667 19.0544 7.14958 19.116L3.93864 20.0603L4.88303 16.8535C4.94052 16.6523 5.03906 16.4675 5.16635 16.3074V16.3033ZM14.446 8.239C14.7006 8.49357 14.7006 8.91239 14.446 9.16697L8.53332 15.0797C8.27874 15.3343 7.85993 15.3343 7.60535 15.0797C7.35077 14.8251 7.35077 14.4063 7.60535 14.1517L13.5181 8.239C13.7727 7.98442 14.1915 7.98442 14.446 8.239Z"
        fill="#DCE5F0"
      />
      <path
        d="M21.7298 3.89178C22.7564 4.9183 22.7564 6.58125 21.7298 7.60777L19.2662 10.0714L13.9283 4.73352L16.392 2.26989C17.4185 1.24337 19.0814 1.24337 20.1079 2.26989L21.7257 3.88767L21.7298 3.89178ZM14.4457 9.16807L8.53296 15.0808C8.27839 15.3354 7.85957 15.3354 7.60499 15.0808C7.35042 14.8262 7.35042 14.4074 7.60499 14.1528L13.5177 8.2401C13.7723 7.98552 14.1911 7.98552 14.4457 8.2401C14.7003 8.49467 14.7003 8.91349 14.4457 9.16807Z"
        fill="#738499"
      />
    </SvgIcon>
  );
};

export default Pencil;
